import { render, staticRenderFns } from "./AlertsList.vue?vue&type=template&id=453717f9&scoped=true"
import script from "./AlertsList.vue?vue&type=script&lang=js"
export * from "./AlertsList.vue?vue&type=script&lang=js"
import style0 from "./AlertsList.vue?vue&type=style&index=0&id=453717f9&prod&lang=scss&scoped=true"
import style1 from "./AlertsList.vue?vue&type=style&index=1&id=453717f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453717f9",
  null
  
)

export default component.exports